import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'throttle-debounce';
import { useFormContext } from 'framework/form';
import { useRecruitmentApi } from 'infrastructure/api';

const useCandidateApplicationDuplicatesHelper = (onDuplicatesFail: () => void) => {
  const { sendPostRequest } = useRecruitmentApi();
  const { data: formData } = useFormContext();
  const [isCandidateApplicationExist, setIsCandidateApplicationExist] = useState(false);

  const search = async (data: any) => {
    const result = await sendPostRequest('/candidates/applications/search', data);
    return result.json();
  };

  // timeout for when the user stopped modifying form content regarding the candidate application
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const searchApplications = useCallback(
    debounce(1000, (id: string, alias: string) => {
      search({
        filter: {
          candidateId: { eq: id },
          vacancyGroupAlias: { eq: alias },
        },
      })
        .then(applicationsResponse => {
          const result = applicationsResponse?.result;
          setIsCandidateApplicationExist(!!result.length);
        })
        .catch(() => {
          setIsCandidateApplicationExist(false);
          onDuplicatesFail();
        });
    }),
    [],
  );

  const vacancyAlias = formData?.vacancyAlias;
  const candidateId = formData?.candidateId;
  useEffect(() => {
    if (candidateId && vacancyAlias) {
      searchApplications(candidateId, vacancyAlias);
    } else {
      setIsCandidateApplicationExist(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateId, vacancyAlias, setIsCandidateApplicationExist, searchApplications]);

  return {
    isCandidateApplicationExist,
  };
};

export default useCandidateApplicationDuplicatesHelper;
